/* eslint-disable no-eval */
import alertUtils from './alertUtils'
// import moduleUtils from './moduleUtils'
// import formUtils from './formUtils'
/**
 * 关于计算字段处理
 */
export default class countUtils {
  /**
   * 生成 字段计算监测
   * @param watcher  this
   * @param widget
   */
  static count(watcher, widget) {
    if (
      widget &&
      Object.prototype.hasOwnProperty.call(widget, 'eventOptions') &&
      widget.eventOptions &&
      Object.prototype.hasOwnProperty.call(widget.eventOptions, 'count') &&
      widget.eventOptions.count &&
      widget.eventOptions.count.list &&
      widget.eventOptions.count.list.length > 0 &&
      widget.eventOptions.count.relation &&
      widget.eventOptions.count.formula
    ) {
      watcher.$watch(
        function () {
          return eval(countUtils.formula(widget))
        },
        function (result) {
          watcher.models[widget.model] = eval(countUtils.result(result, widget))
        }
      )
    }
  }

  /**
   * 生成 计算公式
   * @param watcher
   * @param widget
   * @returns {string}
   */
  static formula(widget) {
    try {
      const list = widget.eventOptions.count.list
      const relation = widget.eventOptions.count.relation
      let formula = widget.eventOptions.count.formula
      const length = list.length
      for (let i = 0; i < length; i++) {
        const model = list[i]
        const str = relation[model]
        if (str) {
          const reg = '/\\' + str + '/g'
          formula = formula.replace(
            eval(reg),
            "watcher.models['" + model + "']"
          )
        }
      }
      return formula
    } catch (e) {
      alertUtils.alertError('自定义计算设置有误，请联系管理人员', true)
    }
  }

  /**
   * 结果集处理
   * @param result  结果数据
   */
  static result(result, widget) {
    const resultStr = widget.eventOptions.count.result
    if (resultStr && resultStr !== null && resultStr !== '') {
      return resultStr
    } else {
      return 'result'
    }
  }
}
